import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import { adminNotificationList as getNotificationList, readAllNotifications, deleteAllNotification } from "../../controllers/V1/notificationController";
import {list as requestList} from "../../controllers/V1/userRequestController";
import {list as pullOutList} from "../../controllers/V1/pullOutRequestController";
import "./main_dashboard.css";

const NotificationDropdown = () => {
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [isLoadingNotifications, setIsLoadingNotifications] = useState(false);
  const notificationRef = useRef(null);
  const adminInfo = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));

  const fetchNotificationCount = async () => {
    try {
      const options = {
        type : "count",
        condition: {
          users_id: adminInfo?._id,
          is_read : "N",
          status: "A"
        },
        sort : { _id: -1 }
      };
      const res = await getNotificationList(options);
      if (res?.status === true) {
        // Calculate unread count
        const unreadCount = res?.result|| 0;
        setNotificationCount(unreadCount);
        console.log("unreadCount", unreadCount);
      }
    } catch (error) {
      console.error("Error fetching notification count:", error);
    }
  };
  // Fetch notification count on component mount
  useEffect(() => {
    if(adminInfo?.notification === "Y"){
      fetchNotificationCount();
    }
  }, []);

  // Fetch notifications
  const fetchNotifications = async () => {
    try {
      setIsLoadingNotifications(true);
      const options = {
        limit: 10,
        skip: 0,
        condition: {
          users_id: adminInfo?._id,
          status: "A"
        },
        sort : { _id: -1 }
      };
      const res = await getNotificationList(options);
      if (res?.status === true) {
        setNotifications(res?.result || []);
        // Calculate unread count
        const unreadCount = res?.result?.reduce((count, notif) => {
          const unread = (notif?.users_list?.length || 0) - (notif?.read_count || 0);
          return count + unread;
        }, 0) || 0;
        setNotificationCount(unreadCount);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setIsLoadingNotifications(false);
    }
  };

  // Toggle notification dropdown
  const toggleNotification = () => {
    if (!showNotification) {
      fetchNotifications();
      //read all notification after 3 seconds
      setTimeout(async () => {
        await readAllNotifications();
        setNotificationCount(0);
      }, 3000);
    }
    setShowNotification(!showNotification);
  };

  // Close notification dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotification(false);
      }
    };

    if (showNotification) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotification]);
  const clearAllNotifications = async () => {
    try {
      const res = await deleteAllNotification();
      if (res?.status === true) {
        fetchNotifications();
      }
    } catch (error) {
      console.error("Error clearing all notifications:", error);
    }
  };
const handleViewNotification = async (data) => {
  try {
    console.log("data : ", data);
    if(data && (data?.type === "New User Request" || data?.type === "Update User Request")){
      const options = {
        type : "single",
        condition : { _id : data?.request_id }
      }
      const requestData = await requestList(options);
      if(requestData?.status === true){
        navigate("/users/request-view",{state : requestData?.result});
      }
    }

    if(data && data?.type === "Pull-Out Request"){
      const options = {
        type : "single",
        condition : { _id : data?.request_id }
      }
      const requestData = await pullOutList(options);
      if(requestData?.status === true){
        navigate("/request/pull-out-view",{state : requestData?.result});
      }
    }
  } catch (error) {
    
  }
}
  return (
    <div className="notification_wrapper" ref={notificationRef}>
      <button 
        className="btn_icon" 
        onClick={toggleNotification}
      >
        <FontAwesomeIcon icon={faBell} />
      </button>
      {notificationCount > 0 && (
        <span className="notification_count">{notificationCount > 99 ? '99+' : notificationCount}</span>
      )}
      {showNotification && (
        <div className="notification_dropdown">
          <div className="notification_dropdown_header">
            <h5>Notifications</h5>
            <Link 
              to="javaScript:void(0)" 
              className="view_all_link"
              onClick={clearAllNotifications}
            >
              Clear All
            </Link>
          </div>
          <div className="notification_dropdown_body">
            {isLoadingNotifications ? (
              <div className="notification_loading">Loading...</div>
            ) : notifications.length > 0 ? (
              notifications.map((notif, index) => {
                const unreadCount = (notif?.users_list?.length || 0) - (notif?.read_count || 0);
                return (
                  <div 
                    key={notif?._id || index} 
                    className={`notification_item ${unreadCount > 0 ? 'unread' : ''}`}
                    onClick={() => handleViewNotification(notif?.data || {})}
                  >
                    <div className="notification_item_content">
                      <h6 className="notification_title">{notif?.title || "No Title"}</h6>
                      <p className="notification_description">
                        {notif?.description || "No description"}
                      </p>
                      <div className="notification_meta">
                        <span className="notification_date">
                          {moment(notif?.createdAt).format("MMM DD, YYYY HH:mm")}
                        </span>
                        {unreadCount > 0 && (
                          <span className="notification_unread_badge">
                            {unreadCount} unread
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="notification_empty">No notifications found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;

